<script>

    import { toast } from 'bulma-toast'
    import { userStore, notifyStore, adminStore } from '../stores'

    import WalletsService from '../$services/wallets.service.js'
    import NumeralMethods from '../$methods/numeral.methods.js'

    import ButtonModal from '../$components/button.modal.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import Spinner from '../$components/spinner.svelte'

    let wallet = null
    let loading = false

    $: $notifyStore === 'wallet_updated' && getWallet() && notifyStore.set(null)

    getWallet()

    async function getWallet() {

        loading = true
        const resp = await WalletsService.getWallet($userStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        wallet = resp.data
    }

</script>

<Spinner {loading} />

{#if !loading}
    <DetailsCard title="Cartera">
        <DetailsFields>
            <DetailsField label="Saldo" value={ NumeralMethods.cash(wallet.amount) } />
        </DetailsFields>
        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <div class="buttons">
                    <ButtonModal modalId="credit_remove_modal" text="Reducir saldo" icon="minus" />
                    <ButtonModal modalId="credit_create_modal" text="Aumentar saldo" icon="plus" />
                </div>
            </div>
        </div>
    </DetailsCard>
{/if}